import {lazy} from "react";

const SearchDepartment = lazy(() => import("./SearchDepartment"));

const departmentRoutes = [
    {
        path: "/department",
        element: <SearchDepartment/>,
    },
];

export default departmentRoutes;